import React from "react";
import { ButtonLoader } from "@stadium/ui/src/components/loaders/loaders";
import styles from "./loaderButton.module.scss";

const ButtonWithLoader = ({
  text,
  children = <></>,
  onClick,
  isLoading,
  disabled = false,
  className = "",
  type = null,
  fillStroke = "",
  style = {},
}) => (
  <button
    type={type || "button"}
    className={`${styles.loaderBtn} ${className} ${disabled ? "disabled" : ""}`}
    disabled={disabled}
    onClick={isLoading || disabled ? undefined : onClick}
    style={style}
  >
    {isLoading && <ButtonLoader fillStroke={fillStroke} wrapperClass={styles.loaderWrapper} />}
    <span className={`${styles.childElem} child-elem`}>{text || children}</span>
  </button>
);

export default ButtonWithLoader;
